import {inject, Injectable} from '@angular/core';
import {BloggerProfileDialogData} from "../types/blogger-modal.types";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {fieldsToReset} from "../configs/blogger-card-modal-config";
import {BloggerDataInRecordData} from "../types/blogger-card.types";
import {RecordData} from "../../../../types/records-table.types";
import {BaseModalService} from "../../services/base-modal.service";

@Injectable({
  providedIn: 'root'
})
export class BloggerProfileService {
  private baseModalService: BaseModalService = inject(BaseModalService);

  public initForm(data: BloggerProfileDialogData): FormGroup {
    const { channelName, channelUrl } = data.recordData;

    return new FormGroup({
      username: new FormControl(channelName, [Validators.required]),
      url: new FormControl(channelUrl, [Validators.required]),
      avatarUrl: new FormControl('', []),
      subscribersCount: new FormControl(0, []),
      videosCount: new FormControl(0, [])
    })
  }

  public resetDialogDataField(dialogData: BloggerProfileDialogData): BloggerProfileDialogData {
    fieldsToReset.forEach(field => {
      dialogData.recordData[field] = {
        id: null,
        valid: false,
        bloggerId: null
      };
    });

    return dialogData;
  }

  public updateBloggerData(recordData: RecordData, bloggerId: number | null): BloggerDataInRecordData {
    return  {
      id: bloggerId,
      recordCalendarId: this.baseModalService.getRecordCalendarId(recordData),
      valid: !!bloggerId
    };
  }
}
